import type { TFeatureFlagGateProps } from './FeatureFlagGate.types.ts';
import { useProjects } from '#providers/projects/use-projects/index.ts';

export const FeatureFlagGate = ({
  flag,
  loading,
  disabled,
  children,
}: TFeatureFlagGateProps) => {
  const { settings, isFeatureEnabled } = useProjects();

  if (!settings) {
    return loading;
  }

  if (!isFeatureEnabled(flag)) {
    return disabled;
  }

  return children;
};
